import { appUrl } from "Utils/UrlUtils";

export const buildCampaignTransactionUrl = (
  transactionPublicID: string,
  campaignCode: string,
  affiliateCode?: string | null,
) => {
  const baseUrl = `${appUrl("customer-payment-pay")}/${transactionPublicID}`;
  const searchParams = new URLSearchParams();

  if (affiliateCode) {
    searchParams.set("affiliateCode", affiliateCode);
  }
  searchParams.set("campaign", campaignCode);

  return `${baseUrl}?${searchParams}`;
};
